<div class="wrapper">
  <div fxFlex="100%" fxLayout="row" fxLayoutGap="2px" fxLayoutAlign="flex-start">
    <div fxFlexFill class="box-left" fxFlex="45%">
      <ng-container *ngIf="site">
        <mat-card class="mat-elevation-z0">
          <mat-card-header class="link" (click)="editSite()" [class.active]="childPath === Url.HospitalDetail">
            <img mat-card-avatar [src]="logoUrl">
            <mat-card-title>{{site.name}}</mat-card-title>
            <mat-card-subtitle>&nbsp;ID: {{site.displayId}}</mat-card-subtitle>
            <div class="flex-spacer"></div>
            <mat-icon class="mat-card-header-action" color="primary">chevron_right</mat-icon>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content>
            <mat-accordion>
              <mat-expansion-panel 
                  class="mat-elevation-z0" 
                  [expanded]="childPath === Url.ServiceDetail || childPath === Url.HospitalDetail || childPath === ''">
                <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
                  <mat-panel-title>
                    <span>
                      <mat-icon>location_on</mat-icon> จุดบริการ
                    </span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-nav-list>
                  <a mat-list-item (click)="openServiceDialog()">
                    <mat-icon matListIcon color="black">add</mat-icon>
                    <span>เพิ่มจุดบริการ</span>
                  </a>
                  <ng-container *ngFor="let service of site.services | keyvalue">
                    <a 
                        mat-list-item [routerLink]="[Url.ServiceDetail, service.value.id]" 
                        [class.active]="childPath === Url.ServiceDetail && childId === service.value.id">
                      <mat-icon class="action" matListIcon color="primary">chevron_right</mat-icon>
                      <span matLine>{{service.value.name}}</span>
                      <span class="subtitle" matLine> ID: {{service.value.displayId}}</span>
                    </a>
                  </ng-container>
                </mat-nav-list>
              </mat-expansion-panel>
              <mat-expansion-panel class=" mat-elevation-z0" [expanded]="childPath === Url.UserDetail">
                <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
                  <mat-panel-title>
                    <span>
                      <mat-icon>account_circle</mat-icon> ผู้ดูแลระบบ
                    </span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-nav-list>
                  <a mat-list-item (click)="openUserDialog()">
                    <mat-icon matListIcon color="black">add</mat-icon>
                    <span>เพิ่มผู้ดูแลระบบ</span>
                  </a>
                  <ng-container *ngFor="let admin of site.admins | keyvalue">
                    <!-- <a mat-list-item (click)="showServiceDetail(service)" > -->
                    <a 
                        mat-list-item [routerLink]="[Url.UserDetail, admin.value.id]" 
                        [class.active]="childPath === Url.UserDetail && childId === admin.value.id">
                      <mat-icon class="action" matListIcon color="primary">chevron_right</mat-icon>
                      <span matLine>{{ admin.value.name }}</span>
                      <span class="subtitle" matLine> {{ admin.value.phone }}</span>
                    </a>
                  </ng-container>
                </mat-nav-list>
              </mat-expansion-panel>
            </mat-accordion>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </div>
    <div class="box-right" fxFlex="55%">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
